import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router'

//Services
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { UserService } from '../../shared/services/user/user.service';

@Component({
  selector: 'app-dashboard-detail-popup',
  templateUrl: './dashboard-detail-popup.component.html',
  styleUrls: ['./dashboard-detail-popup.component.css']
})
export class DashboardDetailPopupComponent {
  constructor(
    private modalService: NgbModal,
    private spinner: Ng4LoadingSpinnerService,
    private userService: UserService,
    private router: Router
  ) { }

  @ViewChild('dashboardDetail') modal: ElementRef;
  showData: Boolean = false
  modalRef: NgbModalRef;
  opportunities: any = []

  navigateToOpportunity(id) {
    this.router.navigate(['opportunities/detail', id]).then(()=>{
      this.modalRef.close()
    });
  }

  navigateToContact(id) {
    this.router.navigate(['contacts/detail', id]).then(()=>{
      this.modalRef.close()
    });
  }

  showModal(data) {
    this.spinner.show()
    this.showData = false
    this.opportunities = []
    let q = JSON.parse(JSON.stringify(data))
    q['cols'][0]['date'].start = q['cols'][0]['date'].start_date
    q['cols'][0]['date'].end = q['cols'][0]['date'].end_date
    if (q['api'] == 'sales') {
      this.getSalesDetail(q)
    } else if (q['api'] == 'potential') {
      this.getPotentialSalesDetail(q)
    } else if (q['api'] == 'won_lost') {
      this.getWonLostDetail(q)
    } else if (q['api'] == 'new_opportunities') {
      this.getNewOpportunitiesDetail(q)
    }
    this.modalRef = this.modalService.open(this.modal, { windowClass: 'dashboard-detail-modal' });
  }

  //Get Sales Report Detail
  getSalesDetail(q) {
    this.userService.getReportBySales(q).subscribe(res => {
      this.userService.getOpportunitiesWithAllData({ ids: this.getUniqueIds(res['data']) }).subscribe(response => {
        this.opportunities = response['data']
        this.showData = true
        this.spinner.hide()
      }, error => {
        this.spinner.hide()
        console.log(error)
      })
    })
  }

  //Get Potential Sales Report Detail
  getPotentialSalesDetail(q) {
    this.userService.getReportByPotentialSales(q).subscribe(res => {
      this.userService.getOpportunitiesWithAllData({ ids: this.getUniqueIds(res['data']) }).subscribe(response => {
        if (response['data'] && response['data'].length > 0) {
          response['data'].map(i => {
            if (i.probability === q.type) {
              this.opportunities.push(i)
            }
          })
        }
        this.showData = true
        this.spinner.hide()
      }, error => {
        this.spinner.hide()
        console.log(error)
      })
    })
  }

  //Get Won/Lost Sales Report Detail
  getWonLostDetail(q) {
    this.userService.getDetailedReportByOpportunityStatus(q).subscribe(res => {
      this.userService.getOpportunitiesWithAllData({ ids: this.getWonLostIds(res['data'], q['type']) }).subscribe(response => {
        if (response['data'] && response['data'].length > 0) {
          this.opportunities = response['data']
        }
        this.showData = true
        this.spinner.hide()
      }, error => {
        this.spinner.hide()
        console.log(error)
      })
    })
  }

  //Get New Opportunities Report Detail
  getNewOpportunitiesDetail(q) {
    this.userService.getNewOpportunities(q).subscribe(res => {
      this.userService.getOpportunitiesWithAllData({ ids: this.getWonLostIds(res['data'], 'none') }).subscribe(response => {
        if (response['data'] && response['data'].length > 0) {
          this.opportunities = response['data']
        }
        this.showData = true
        this.spinner.hide()
      }, error => {
        this.spinner.hide()
        console.log(error)
      })
    })
  }

  getUniqueIds(data) {
    let ids = []
    for (let oKey in data) {
      for (let iKey in data[oKey]) {
        data[oKey][iKey].map(i => {
          if (ids.findIndex(a => a === i.oppty_id) === -1) {
            ids.push(i.oppty_id)
          }
        })
      }
    }
    return ids
  }

  getWonLostIds(data, type) {
    let ids = []
    for (let oKey in data) {
      data[oKey].map(i => {
        if (ids.findIndex(a => a === i.oppty_id) === -1) {
          if (type === 'won') {
            if (i.oppty_status_type_id === 2) {
              ids.push(i.oppty_id)
            }
          } else if (type === 'lost') {
            if (i.oppty_status_type_id === 3) {
              ids.push(i.oppty_id)
            }
          } else {
            ids.push(i.oppty_id)
          }
        }
      })
    }
    return ids
  }

  formatAddress(addr) {
    return addr.split(';')[0].replace(/,/g, '').replace(/  +/g, ' ')
  }

  showTotal() {
    let price = 0
    this.opportunities.map(i => {
      price += parseInt(i.price)
    })
    return price
  }

  showCount() {
    return this.opportunities.length
  }

  showAverage(total, count) {
    return Math.round(total / count)
  }
}



// WEBPACK FOOTER //
// ./src/app/dashboard/dashboard-detail-popup/dashboard-detail-popup.component.ts